export default __webpack_public_path__ + "static/media/service1.ce8e09a9.jpg";